import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onToggleSelectionAction = useOnToggleSelection(props)
  let onRemoveMatchAction = useOnRemoveMatch(props)
  let onReplaceMatchAction = useOnReplaceMatch(props)
  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'TOGGLE_SELECTION': {
        onToggleSelectionAction()
        return
      }
      case 'REMOVE_MATCH': {
        onRemoveMatchAction()
        return
      }
      case 'REPLACE_MATCH': {
        onReplaceMatchAction(args.internal)
        return
      }
      default:
        return
    }
  }
}

function useOnToggleSelection(props) {
  return function onToggleSelection() {
    if (typeof props.onToggleSelection === 'function') {
      props.onToggleSelection()
    }
  }
}

function useOnRemoveMatch(props) {
  return function onRemoveMatch() {
    if (typeof props.onRemoveMatch === 'function') {
      props.onRemoveMatch()
    }
  }
}

function useOnReplaceMatch(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onReplaceMatch(internal) {
    if (typeof props.onReplaceMatch === 'function') {
      props.onReplaceMatch(internal)
    }
    setFlowTo(normalizePath(props.viewPath, 'ReplacePatient/Content/No'))
  }
}
